export default "__VITE_ASSET__uHO$D91A__"